'use client';

import { Badge, TypographyH1 } from '@/components';
import { useProductValue } from '@/context';

const ProductTitle = () => {
  const { name, specialOffer } = useProductValue();

  return (
    <TypographyH1 className='flex items-center gap-2 text-2xl'>
      {name}
      {specialOffer ? (
        <Badge variant='danger' className='p-1.5 max-lg:hidden'>
          فروش ویژه
        </Badge>
      ) : null}
    </TypographyH1>
  );
};

export { ProductTitle };
